import type { PortalRole, PortalPermission } from '../types/api.js';
import { checkPermission, PORTAL_PERMISSIONS } from '@cortex/core-types';

/**
 * 権限定義（@cortex/core-types から中央集権管理）
 *
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business 権限マップ定数。@cortex/core-typesのPORTAL_PERMISSIONSを再エクスポート
 * @graph-connects none
 */
export const PERMISSIONS = PORTAL_PERMISSIONS;

export type Permission = PortalPermission;

/**
 * ユーザーが指定された権限を持っているかチェック（ロール + チーム条件対応）
 *
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business ユーザーロール・チーム名とPermissionキーを照合し、権限の有無を判定
 * @graph-connects none
 */
export function hasPermission(
  userRole: PortalRole | undefined,
  permission: Permission,
  userTeamName?: string,
): boolean {
  return checkPermission(userRole ? [userRole] : undefined, permission, userTeamName);
}

/**
 * ユーザーが指定されたロールのいずれかを持っているかチェック
 *
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business ユーザーロールが指定ロール配列のいずれかに含まれるか判定
 * @graph-connects none
 */
export function hasRole(userRole: PortalRole | undefined, roles: readonly PortalRole[]): boolean {
  if (!userRole) return false;
  return roles.includes(userRole);
}
